import {TLinkDto} from 'shared/types/links';
import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';

export const getCustomLinkConfig = (url: string) => (
    performRequest<TLinkDto>({
        url,
        method: ERequestType.GET,
    })
);
